<div class="boletas-container">
  <!-- Título y subtítulo -->
  <app-page-header
    [title]="'Solicitudes'"
    [subtitle]="'Administra tus solicitudes'"
  ></app-page-header>

  <!-- Botones, combo y barra de búsqueda -->
  <app-page-acciones
    [hasButton]="true"
    [buttonText]="'Exportar Excel'"
    [buttonIcon]="'pi pi-download'"
    [buttonColor]="'#04a563'"
    [textButtonColor]="'white'"
    [buttonDisabled]="isExporting"
    (buttonClick)="exportExcel()"
    [comboOptions]="monthOptions"
    [comboSelected]="currentMonth"
    (comboSelectedChange)="onMonthChange($event)"

    [yearOptions]="yearOptions"
    [yearSelected]="selectedYear"
    (yearSelectedChange)="onYearChange($event)"
    
    [searchQuery]="searchTerm"
    (searchQueryChange)="onSearch($event)"
  >
  </app-page-acciones>

  <!-- Tabs y tabla dinámica -->
  <app-page-container
    [contentContainerClass]="'solicitude-container'"
    [tabs]="tabs"
    [displayedColumns]="displayedColumns"
    [dataSource]="dataSource"
    [actionButtons]="actionButtons"
    [headerClass]="currentHeaderClass"
    [showPreviewCard]="false"
    [isLoading]="isLoading"
    [useServerPagination]="true"
    [paginationLength]="totalElements"
    [pageIndex]="pageIndex"
    [pageSize]="pageSize"
    [customTemplates]="{
      ultimaActualizacion: ultimaActualizacionTemplate,
      persona: personaTemplate
    }"
    (tabSelected)="onTabSelected($event)"
    (rowSelected)="onRowSelected($event)"
    (pageChange)="onPageChange($event)"
    [selectedDocument]="selectedDocument"
    [hasCheckbox]="true"
  >
    <ng-template #ultimaActualizacionTemplate let-row>
      {{ row.ultimaActualizacion || "No hay actualización" }}
    </ng-template>
    <ng-template #personaTemplate let-row>
      {{ row.persona | capitalize }}
    </ng-template>
  </app-page-container>

  <!-- Modal del detalle -->
  <div class="update-state-modal">
    <app-update-state-modal
      [(visible)]="viewVacation"
      [dataToView]="dataDetail"
      (visibleChange)="onDialogDetailClose()"
      (updateStateComplete)="onUpdateStateComplete()"
    >
    </app-update-state-modal>
  </div>
</div>
